import React, { useState } from "react";
import { Calendar } from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"

import persian_fa from "react-date-object/locales/persian_fa"
import arrowleft from "../../assets/img/icons/arrow-left.svg";
import arrowright from "../../assets/img/icons/arrow-right.png";
const Datebox = ({ className ,selectedDay,setSelectedDay}) => {

  return (
    <div
      className={`datebox dropbox-absolute ${className}`}
      onClick={e => e.stopPropagation()}
    >
    <Calendar
        value={selectedDay}
        onChange={setSelectedDay}
        showOtherDays
        calendar={persian}
        locale={persian_fa}
        disableYearPicker
        format='YYYY/MM/DD'
        mapDays={({ date }) => {
          let props = {}
          let isWeekend = [ 6].includes(date.weekDay.index)
          if (isWeekend) props.className = "weekend-red"
          return props
        }}
        renderButton={(direction, handleClick) => (
          <button className='arrow-button' onClick={handleClick}>
            {direction === "left" ? <img src={arrowright}/> : <img src={arrowleft}/>}
          </button>
        )}
      />
    </div>
  );
};

export default Datebox;

//  calendarClassName="custom-calendar" // and this
//         calendarTodayClassName="custom-today-day" // also this